import { call, put, select, takeEvery } from 'redux-saga/effects'

import { selectAuthToken } from '@store/auth'
import { fetchCampaign, fetchCampaigns, ICampaign, selectCopyCampaignLink } from '@store/campaigns'
import {
  copyCampaign,
  copyCampaignError,
  copyCampaignSuccess,
} from '@store/campaigns/actions/copyCampaign'
import { Toaster } from '@tribegroup'
import networkRequest from '@utils/networkRequest'

export function* handleCopyCampaign(action: ReturnType<typeof copyCampaign>) {
  const { campaignId, onSuccess, successMessage } = action.payload

  try {
    const copyCampaignLink = yield select(selectCopyCampaignLink, campaignId)
    const authToken = yield select(selectAuthToken)

    const campaign: ICampaign = yield call(
      networkRequest,
      copyCampaignLink.method,
      copyCampaignLink.href,
      undefined,
      authToken,
    )

    yield put(fetchCampaign(campaign.id))
    yield put(fetchCampaigns(campaign.status))
    yield put(copyCampaignSuccess(campaignId))
    if (onSuccess) {
      yield call(onSuccess)
    }
    if (successMessage) {
      yield call(Toaster.toast, successMessage)
    }
  } catch (error) {
    yield put(copyCampaignError(campaignId, error))
  }
}

export function* watchCopyCampaign() {
  yield takeEvery(copyCampaign, handleCopyCampaign)
}
